import type { MatchState, PlayerState } from "@arcade-hockey/sim";

// The role table is filled per tick and consumed by behaviors. In slice 3 the
// classification is purely a function of puck ownership (no per-team rank
// yet) so role discovery is O(players). Slice 4 will extend this with
// rank-based primary/deep support and pressurer/defender distinction.
export type BotRole =
  | "carrier" // owns the puck this tick
  | "support" // teammate of the puck owner
  | "defender" // opposing team has the puck — apply pressure
  | "chaser"; // puck is loose / in flight — go get it

export function classifyRole(player: PlayerState, state: MatchState): BotRole {
  if (state.puck.ownerId === null) return "chaser";
  const carrier = state.playersById.get(state.puck.ownerId);
  if (carrier === undefined) return "chaser";
  if (carrier.id === player.id) return "carrier";
  if (carrier.teamId === player.teamId) return "support";
  return "defender";
}
